<template>
  <path
    d="M20 4.00024H16.83L15.59 2.65024C15.22 2.24024 14.68 2.00024 14.12 2.00024H9.88C9.32 2.00024 8.78 2.24024 8.4 2.65024L7.17 4.00024H4C2.9 4.00024 2 4.90024 2 6.00024V18.0002C2 19.1002 2.9 20.0002 4 20.0002H20C21.1 20.0002 22 19.1002 22 18.0002V6.00024C22 4.90024 21.1 4.00024 20 4.00024ZM15 15.5002V13.0002H9V15.5002L5.85 12.3502C5.65 12.1502 5.65 11.8402 5.85 11.6402L9 8.50024V11.0002H15V8.50024L18.15 11.6502C18.35 11.8502 18.35 12.1602 18.15 12.3602L15 15.5002Z"
  />
</template>
